<p8-settings-page>
  <p8-settings-header [titlePath]="['Backoffice']"></p8-settings-header>

  <div style="padding-top: 20px;">
    <h4>Cette page vous permet d’accéder de gérer la banque de connaissances.</h4>
    <mat-list style="padding-left: 40px;">
      <h3 mat-subheader>Le(s) rôle(s) que vous détenez :</h3>
      <mat-list-item *ngFor="let role of roles">
        <mat-icon matListItemIcon>account_box</mat-icon>
        <h4 mat-line>{{role}}</h4>
      </mat-list-item>
    </mat-list>
  </div>

</p8-settings-page>

